import { task } from 'ember-concurrency';
import { action } from '@ember/object';
import { notEmpty, readOnly } from '@ember/object/computed';
import { PROJECTS_SORT_OPTIONS, PROJECTS_SORT_API_ENUMS } from 'sh-www/constants/routes/projects';
import { APPLICATION_SIMPLE_STATUS } from 'sh-www/models/application';

import { createCache, sellerProjectsViewControllerFactory } from './seller';

const sortOptions = Object.freeze({
  [PROJECTS_SORT_OPTIONS.LAST_ACTIVITY]: PROJECTS_SORT_API_ENUMS.LAST_ACTIVITY,
});

class SellerProjectsSearchViewController extends sellerProjectsViewControllerFactory({
    sortOptions,
    defaultFilter: APPLICATION_SIMPLE_STATUS.STARTED,
}) {
  get emptyText() {
    return "You don't have any matching projects";
  }

  @readOnly('cache.search')
  searchValue;

  @notEmpty('cache.search')
  showResults;

  @action
  setSearchQuery(query) {
    this.set('search', query?.trim() || null);
  }

  @task({ group: 'modelUpdates' })
  *initializeModel(queryParams) {
    const cache = this.set('cache', createCache(queryParams));

    if (!cache.search) {
      this.setProperties({ data: [], meta: null });
      return;
    }

    yield this.updateModel.perform(1);
  }
}

export default SellerProjectsSearchViewController;
